export default __webpack_public_path__ + "static/media/26.9f2adea3.png";